import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import image1 from '../assets/contact/image1.png';
import image2 from '../assets/contact/image2.png';
import './Main.css';

const Contact = () => {
    const navigate = useNavigate();
    const [size, setSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    });

    useEffect(() => {
    const handleResize = () => {
        setSize({
        width: window.innerWidth,
        height: window.innerHeight,
        });
    };

    window.addEventListener('resize', handleResize);

    // 컴포넌트 언마운트 시 이벤트 제거
    return () => window.removeEventListener('resize', handleResize);
    }, []);

    const goToGallery = () => {
        navigate('/pages/gallery')
    }

    const goToAbout = () => {
        navigate('/pages/about')
    }

    const goToContact = () => {
        navigate('/pages/contact')
    }

    return(
        <div style={{display: "flex", flexDirection: "column", alignItems: "center", padding: "0px 8px",}}>
            {size.width > 768 && 
            <div style={{display: "flex", justifyContent: "center", gap: 32, marginBottom: 96}}>
                <div onClick={goToGallery} className="nav-item">GALLERY</div>
                <div onClick={goToAbout} className="nav-item">ABOUT</div>
                <div onClick={goToContact} className="nav-item">CONTACT</div>
            </div>}
            <div style={{fontSize: 42, fontWeight: 300, marginBottom: 32}}>
                Reservation inquiry
            </div>
            <div style={{fontSize: 28, fontWeight: 300, marginBottom: 64}}>
                예약문의
            </div>
            <img src={image1} style={{width: size.width <= 1280 ? size.width - 16 : 1280, height: "auto"}} />
            <div style={{width: size.width <= 1280 ? size.width - 16 : 1280, display: "flex", textAlign: "center", fontSize: 16, fontWeight: 400, lineHeight: 2, marginTop: 64, marginBottom: 64}}>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis. 
            </div>

            <div style={{width: size.width <= 1280 ? size.width - 16 : 1280, display: "flex", flexDirection: size.width > 768 ? "row" : "column", alignItems: "center", justifyContent: "center", gap: 80, marginBottom: 64}}>
                <img src={image2} style={{width: size.width <= 1280 ? (size.width - 96)/2 : 600, height: "auto"}} />
                <div style={{width: size.width <= 1280 ? (size.width - 96)/2 : 600, }}>
                    <div style={{fontSize: 26, fontWeight: 500, marginBottom: 16,}}>생활의 기본, 삶의 터전, 새로운 시작과</div>
                    <div style={{fontSize: 26, fontWeight: 500, marginBottom: 64,}}>늘 함께하는 [housefix]_</div>
                    <div style={{display: "flex", height: 1, backgroundColor: '#E2E5E8', marginBottom: 64}} />
                    <div style={{display: "flex", alignItems: "center", marginBottom: 32}}>
                        <div style={{width: 120, fontSize: 14, fontWeight: 700}}>Address</div>
                        <div style={{fontSize: 14, fontWeight: 400}}>영주시 대학로 77 148아트스퀘어 2층 6호</div>
                    </div>
                    <div style={{display: "flex", alignItems: "center", marginBottom: 32}}>
                        <div style={{width: 120, fontSize: 14, fontWeight: 700}}>Email</div>
                        <div style={{fontSize: 14, fontWeight: 400}}>housefix@kakao.com</div>
                    </div>
                    <div style={{display: "flex", alignItems: "center", marginBottom: 32}}>
                        <div style={{width: 120, fontSize: 14, fontWeight: 700}}>Call</div>
                        <div style={{fontSize: 14, fontWeight: 400}}>010-3091-9095</div>
                    </div>
                    <div style={{display: "flex", alignItems: "center", marginBottom: 32}}>
                        <div style={{width: 120, fontSize: 14, fontWeight: 700}}>Instagram</div>
                        <div style={{fontSize: 14, fontWeight: 400}}>@housefix_official</div>
                    </div>
                </div>
            </div>

            <div style={{width: size.width <= 1280 ? size.width - 16 : 1280, height: 1, backgroundColor: '#E2E5E8',}} />
        </div>
    )
}

export default Contact;